import Job from './job'
import PaginatedCollection from './paginated_collection'

import activityFactory from '../activity_factory'

function modelIds (polls = [], surveys = [], competitions = []) {
  return {
    poll_ids: polls.map(p => p.id),
    survey_ids: surveys.map(s => s.id),
    competition_ids: competitions.map(c => c.id)
  }
}

class DeletedActivitiesCollection extends PaginatedCollection {
  url () {
    return '/api/trash'
  }

  model (attrs, options) {
    return activityFactory(attrs, options)
  }

  restore (polls, surveys, competitions, targetGroupId = -1) {
    const ids = modelIds(polls, surveys, competitions)
    return Job.create(`/api/activities/move/to_group/${targetGroupId}`, ids)
  }

  delete (polls, surveys, competitions) {
    const ids = modelIds(polls, surveys, competitions)
    return Job.create('/api/activities/delete', ids)
  }
}

export default DeletedActivitiesCollection
